import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';

import type { Color } from '@opendoor/tokens-studio/dist/bricks-next/types/Novo';
import { getToken } from '@tamagui/core';

type BricksSvgProps = Omit<SvgProps, 'width' | 'height' | 'color'> & {
  size?: 20 | 24,
  color?: Color,
};
const SvgMenu = ({ size = 24, color = '$contentPrimary', ...inProps }: BricksSvgProps) => {
  const outProps: SvgProps = {};
  if (size) {
    outProps.width = size;
    outProps.height = size;
  }
  if (color) {
    const colorToken = getToken(color, 'color');
    outProps.color = colorToken;
  }
  const props = {
    viewBox: '0 0 24 24',
    ...inProps,
    ...outProps,
  };
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <Path
        fill="currentColor"
        fillRule="evenodd"
        d="M20 10H4V8h16zM20 16H4v-2h16z"
        clipRule="evenodd"
      />
    </Svg>
  );
};
export default SvgMenu;
